import React from "react";
import { AppList } from "components/list/AppList";

import { Datagrid, TextField, ReferenceField, FunctionField } from "react-admin";

import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { DateTimeField } from "../../../components/fields/DateFormatField";

import { LoginLogsFilter } from "./ListFilters";

import { YesNoField } from "components/fields/YesNoField";

const defaultSort = { field: "created_at", order: "DESC" };

export const LoginLogsList = (props) => {
	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<LoginLogsFilter />}
		>
			<ScrollingWrapper>
				<Datagrid
					rowClick="show"
					rowStyle={(record, index) => {
						return {
							height: "48px",
							backgroundColor: record.is_successful ? "#d4edda" : "#f8d7da", // light green for success, light red for failure
						};
					}}
				>
					<TextField source="user_id" sortable={false} />
					<TextField source="user_role" sortable={false} />
					<DateTimeField source="created_at" label="Logged at" />
					<TextField source="email" sortable={false} />
					<ReferenceField source="user_id" reference="users" link={false} sortable={false}>
						<FunctionField render={(record) => `${record.first_name} ${record.last_name}`} />
					</ReferenceField>
					<YesNoField source="is_successful" label="Successful Login" sortable={false}/>
					<TextField source="ip_address" sortable={false} />
					<TextField source="location" sortable={false} />
					<TextField source="user_agent" sortable={false} />
					<YesNoField source="logged_via_code" sortable={false}/>
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
